export default {
  "bonusRecord.title": "Bonus Records",
  "bonusRecord.action.details": "Details",
  "bonusRecord.copy.success": "Copied to clipboard",
  "bonusRecord.tooltip.copy.userNo": "Copy UserNo: {text}",
  "bonusRecord.tooltip.showUserDetails": "Show User Details",
  "bonusRecord.modal.title.details": "Details",
  "bonusRecord.modal.title.userDetails": "User Details",
  "bonusRecord.column.no": "#NO",
  "bonusRecord.column.userNo": "UserNo",
  "bonusRecord.column.email": "Email",
  "bonusRecord.column.name": "Name",
  "bonusRecord.column.firstName": "Firs tName",
  "bonusRecord.column.lastName": "Last Name",
  "bonusRecord.column.inviterUserno": "Inviter UserNo",
  "bonusRecord.column.inviterEmail": "Inviter Email",
  "bonusRecord.column.inviterName": "Inviter Name",
  "bonusRecord.column.inviterFirstName": "InviterFirstName",
  "bonusRecord.column.inviterLastName": "InviterLastName",
  "bonusRecord.column.bonusCategory": "Bonus Category",
  "bonusRecord.column.channel": "Channel",
  "bonusRecord.column.referral": "Referral",
  "bonusRecord.column.vipLevel": "Vip Level",
  "bonusRecord.column.lastLoginIp": "Last Login IP",
  "bonusRecord.column.bonusAmount": "Bonus Amount",
  "bonusRecord.column.todayReceiveNum": "Today Receive Num",
  "bonusRecord.column.yesterdayReceiveNum": "Yesterday Receive Num",
  "bonusRecord.column.totalReceiveNum": "Total Receive Num",
  "bonusRecord.column.lastReceiveTime": "Last Receive Time",
  "bonusRecord.column.action": "Action",
  "bonusRecord.search.createTime": "Create Time",
  "bonusRecord.search.userNo": "UserNo",
  "bonusRecord.search.email": "Email",
  "bonusRecord.search.firstName": "First Name",
  "bonusRecord.search.lastName": "Last Name",
  "bonusRecord.search.inviterUserno": "Inviter UserNo",
  "bonusRecord.search.inviterEmail": "Inviter Email",
  "bonusRecord.search.inviterFirstName": "Inviter First Name",
  "bonusRecord.search.inviterLastName": "Inviter Last Name",
  "bonusRecord.search.vipLevel": "Vip Level",
  "bonusRecord.search.bonusCategory": "Bonus Category",
};
